import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/midders/Code/xedi-microservices/sdk-js/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { CheckIcon } from '@primer/styled-octicons';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Introduction`}</h2>
    <p>{`An Network Connection API allows you to set up and retrieve network connection information.`}</p>
    <h2>{`Usage`}</h2>
    <h3>{`list`}</h3>
    <p>{`Retrieve a list of NetworkConnections.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`pageNumber`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Usage`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const networkConnections = await Xedi.NetworkConnections.list();
`}</code></pre>
    <h4>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`
{
    "current_page": 1,
    "data": [
        {
         "_id": "af6d8dfc-88b5-41f6-bbf5-825130390d64",
         "partnership_id": "af6d8dfc-88b5-41f6-bbf5-825130390d64",
         "from_mailbox": "cefda3331-ds33-41f6-bbf5-825130390d64",
         "to_mailbox" : "e939d2d7-1376-4ecb-bff4-e32356e3ae78",
         "network_status": "PENDING",
         "connection_type": "FTP",
         "created_at": "2020-05-11 10:27:03",
         "updated_at": "2020-05-11 10:27:03"
        },
        {
          "_id": "4asda4sda-88b5-41f6-bbf5-j43423432432j",
          "partnership_id": "af6d8dfc-88b5-41f6-bbf5-825130390d64",
          "from_mailbox": "cefda3331-ds33-41f6-bbf5-825130390d64",
          "to_mailbox" : "e939d2d7-1376-4ecb-bff4-e32356e3ae78",
          "network_status": "inactive",
          "connection_type": "FTP",
          "created_at": "2020-05-11 10:27:03",
          "updated_at": "2020-05-11 10:27:03"
        }
    ]
}

`}</code></pre>
    <h3>{`get`}</h3>
    <p>{`Retrieve a Network Connection by Id.`}</p>
    <h4>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'af6d8dfc-88b5-41f6-bbf5-825130390d64'`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Usage`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const networkConnection = await Xedi.NetworkConnections.get('af6d8dfc-88b5-41f6-bbf5-825130390d64');
`}</code></pre>
    <h4>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
   "_id": "af6d8dfc-88b5-41f6-bbf5-825130390d64",
   "partnership_id": "af6d8dfc-88b5-41f6-bbf5-825130390d64",
   "from_mailbox": "cefda3331-ds33-41f6-bbf5-825130390d64",
   "to_mailbox" : "e939d2d7-1376-4ecb-bff4-e32356e3ae78",
   "network_status": "PENDING",
   "connection_type": "FTP",
   "created_at": "2020-05-11 10:27:03",
   "updated_at": "2020-05-11 10:27:03"
}
`}</code></pre>
    <h3>{`Create`}</h3>
    <p>{`Create a new Network Connection`}</p>
    <h4>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`partnership_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'hsahdhasd-88b5-41f6-bbf5-432423432re'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`to_mailbox`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'ddasdasd-88b5-41f6-bbf5-far3q42444'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`from_mailbox`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'sfafafasd-88b5-41f6-bbf5-432432432'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`network_status`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'pending'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`connection_type`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'FTP'`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Usage`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const networkConnection = await Xedi.NetworkConnections.create(
    {
      "partnership_id": "af6d8dfc-88b5-41f6-bbf5-825130390d64",
      "from_mailbox": "cefda3331-ds33-41f6-bbf5-825130390d64",
      "to_mailbox" : "e939d2d7-1376-4ecb-bff4-e32356e3ae78",
      "network_status": "PENDING",
      "connection_type": "FTP"
    }
);
`}</code></pre>
    <h4>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
     "_id": "af6d8dfc-88b5-41f6-bbf5-825130390d64",
     "partnership_id": "af6d8dfc-88b5-41f6-bbf5-825130390d64",
     "from_mailbox": "cefda3331-ds33-41f6-bbf5-825130390d64",
     "to_mailbox" : "e939d2d7-1376-4ecb-bff4-e32356e3ae78",
     "network_status": "PENDING",
     "connection_type": "FTP",
     "created_at": "2020-05-11 10:27:03",
     "updated_at": "2020-05-11 10:27:03"
}
`}</code></pre>
    <h3>{`Update`}</h3>
    <p>{`Update an existing Network Connection`}</p>
    <h4>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'af6d8dfc-88b5-41f6-bbf5-825130390d64'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`partnership_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'hsahdhasd-88b5-41f6-bbf5-432423432re'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`to_mailbox`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'ddasdasd-88b5-41f6-bbf5-far3q42444'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`from_mailbox`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'sfafafasd-88b5-41f6-bbf5-432432432'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`network_status`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'pending'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`connection_type`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'FTP'`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Usage`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const networkConnections = await Xedi.NetworkConnections.update(
    {
         "_id": "af6d8dfc-88b5-41f6-bbf5-825130390d64",
         "partnership_id": "af6d8dfc-88b5-41f6-bbf5-825130390d64",
         "from_mailbox": "cefda3331-ds33-41f6-bbf5-825130390d64",
         "to_mailbox" : "e939d2d7-1376-4ecb-bff4-e32356e3ae78",
         "network_status": "INACTIVE",
         "connection_type": "FTP",
    }
);
`}</code></pre>
    <h4>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`    {
       "_id": "af6d8dfc-88b5-41f6-bbf5-825130390d64",
       "partnership_id": "af6d8dfc-88b5-41f6-bbf5-825130390d64",
       "from_mailbox": "cefda3331-ds33-41f6-bbf5-825130390d64",
       "to_mailbox" : "e939d2d7-1376-4ecb-bff4-e32356e3ae78",
       "network_status": "INACTIVE",
       "connection_type": "FTP",
       "created_at": "2020-05-11 10:27:03",
       "updated_at": "2020-05-11 10:27:03"
    }
`}</code></pre>
    <h3>{`Delete`}</h3>
    <p>{`Delete a Network Connection. Response contains a deleted_at flag which signifies it has been deleted.`}</p>
    <h4>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Xuid`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><CheckIcon color="green.5" mdxType="CheckIcon" /></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`'3n1jnj13-88b5-41f6-bbf5-m31kmk31mk1m31'`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Usage`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const networkConnection = await Xedi.NetworkConnections.delete('3n1jnj13-88b5-41f6-bbf5-m31kmk31mk1m31');
`}</code></pre>
    <h4>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`    {
        "_id": "3n1jnj13-88b5-41f6-bbf5-m31kmk31mk1m31"
    }
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      